import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueResource from 'vue-resource'
import "./filters/filters.js"
import _ from 'lodash'

Vue.use(VueResource)
Vue.config.productionTip = false
Vue.config.devtools = true
Vue.config.performance = true



async function initialize() {
  window.apikey = await store.dispatch('get_token');
  setInterval(function(){
    window.apikey = store.dispatch('get_token');
  }, 30000);
  let _loaders = {
    translation: await store.dispatch('load', {mode: '/contributions/7/12', params: {data: 'translation'}}),
    services:    await store.dispatch('load', {mode: '/contributions/4/11', params: {references: 'false', data: 'translation'}}),
    genres:      await store.dispatch('load', {mode: '/contributions/4/6',  params: {references: 'false', data: 'translation'}}),
    mediatypes:  await store.dispatch('load', {mode: '/contributions/4/9',  params: {references: 'false', data: 'translation'}}),
    languages:   await store.dispatch('load', {mode: '/contributions/4/3',  params: {references: 'false', data: 'translation'}}),
    integration: await store.dispatch('load', {mode: '/contributions/9/14', params: {populate: 'true'}}),
    translation_parsed: {},
    translation_byid: {},
    services_parsed: [],
    genres_parsed: [],
    mediatypes_parsed: [],
    languages_parsed: [],
    services_byid: {},
    genres_byid: {},
    mediatypes_byid: {},
    languages_byid: {},
    integration_parsed: [],
    integration_byid: {},
    kanton: ["AG","AI","AR","BE","BL","BS","FR","GE","GL","GR","JU","LU","NE","NW","OW","SG","SH","SO","SZ","TG","TI","UR","VD","VS","ZH","ZG"],
    land: ["CH_Schweiz","DE_Deutschland","IT_Italien","AT_\u00d6sterreich","FR_Frankreich","GB_Gro\u00dfbritannien und Nordirland","AD_Andorra","AE_Vereinigte Arabische Emirate","AF_Afghanistan","AG_Antigua und Barbuda","AI_Anguilla","AL_Albanien","AM_Armenien","AN_Niederl\u00e4ndische Antillen","AO_Angola","AQ_Antarktis","AR_Argentinien","AS_Amerikanisch-Samoa","AU_Australien","AW_Aruba","AX_\u00c5land","AZ_Aserbaidschan","BA_Bosnien und Herzegowina","BB_Barbados","BD_Bangladesch","BE_Belgien","BF_Burkina Faso","BG_Bulgarien","BH_Bahrain","BI_Burundi","BJ_Benin","BM_Bermuda","BN_Brunei Darussalam","BO_Bolivien","BR_Brasilien","BS_Bahamas","BT_Bhutan","BV_Bouvetinsel","BW_Botswana","BY_Belarus (Wei\u00dfrussland)","BZ_Belize","CA_Kanada","CC_Kokosinseln (Keelinginseln)","CD_Kongo","CF_Zentralafrikanische Republik","CG_Republik Kongo","CI_Elfenbeink\u00fcste","CK_Cookinseln","CL_Chile","CM_Kamerun","CN_China, Volksrepublik","CO_Kolumbien","CR_Costa Rica","CU_Kuba","CV_Kap Verde","CX_Weihnachtsinsel","CY_Zypern","CZ_Tschechische Republik","DJ_Dschibuti","DK_D\u00e4nemark","DM_Dominica","DO_Dominikanische Republik","DZ_Algerien","EC_Ecuador","EE_Estland (Reval)","EG_\u00c4gypten","EH_Westsahara","ER_Eritrea","ES_Spanien","ET_\u00c4thiopien","FI_Finnland","FJ_Fidschi","FK_Falklandinseln (Malwinen)","FM_Mikronesien","FO_F\u00e4r\u00f6er","GA_Gabun","GD_Grenada","GE_Georgien","GF_Franz\u00f6sisch-Guayana","GG_Guernsey (Kanalinsel)","GH_Ghana","GI_Gibraltar","GL_Gr\u00f6nland","GM_Gambia","GN_Guinea","GP_Guadeloupe","GQ_\u00c4quatorialguinea","GR_Griechenland","GS_S\u00fcdgeorgien und die S\u00fcdl. Sandwichinseln","GT_Guatemala","GU_Guam","GW_Guinea-Bissau","GY_Guyana","HK_Hongkong","HM_Heard- und McDonald-Inseln","HN_Honduras","HR_Kroatien","HT_Haiti","HU_Ungarn","ID_Indonesien","IE_Irland","IL_Israel","IM_Insel Man","IN_Indien","IO_Britisches Territorium im Indischen Ozean","IQ_Irak","IR_Iran","IS_Island","JE_Jersey (Kanalinsel)","JM_Jamaika","JO_Jordanien","JP_Japan","KE_Kenia","KG_Kirgisistan","KH_Kambodscha","KI_Kiribati","KM_Komoren","KN_St. Kitts und Nevis","KP_Nordkorea","KR_S\u00fcdkorea","KW_Kuwait","KY_Kaimaninseln","KZ_Kasachstan","LA_Laos","LB_Libanon","LC_St. Lucia","LI_Liechtenstein","LK_Sri Lanka","LR_Liberia","LS_Lesotho","LT_Litauen","LU_Luxemburg","LV_Lettland","LY_Libyen","MA_Marokko","MC_Monaco","MD_Moldawien","MG_Madagaskar","MH_Marshallinseln","MK_Mazedonien","ML_Mali","MM_Myanmar (Burma)","MN_Mongolei","MO_Macau","MP_N\u00f6rdliche Marianen","MQ_Martinique","MR_Mauretanien","MS_Montserrat","MT_Malta","MU_Mauritius","MV_Malediven","MW_Malawi","MX_Mexiko","MY_Malaysia","MZ_Mosambik","NA_Namibia","NC_Neukaledonien","NE_Niger","NF_Norfolkinsel","NG_Nigeria","NI_Nicaragua","NL_Niederlande","NO_Norwegen","NP_Nepal","NR_Nauru","NU_Niue","NZ_Neuseeland","OM_Oman","PA_Panama","PE_Peru","PF_Franz\u00f6sisch-Polynesien","PG_Papua-Neuguinea","PH_Philippinen","PK_Pakistan","PL_Polen","PM_St. Pierre und Miquelon","PN_Pitcairninseln","PR_Puerto Rico","PS_Pal\u00e4stina","PT_Portugal","PW_Palau","PY_Paraguay","QA_Katar","RE_R\u00e9union","RO_Rum\u00e4nien","RU_Russische F\u00f6deration","RW_Ruanda","SA_Saudi-Arabien","SB_Salomonen","SC_Seychellen","SD_Sudan","SE_Schweden","SG_Singapur","SH_St. Helena","SI_Slowenien","SJ_Svalbard und Jan Mayen","SK_Slowakei","SL_Sierra Leone","SM_San Marino","SN_Senegal","SO_Somalia","SR_Suriname","ST_S\u00e3o Tom\u00e9 und Pr\u00edncipe","SV_El Salvador","SY_Syrien","SZ_Swasiland","TC_Turks- und Caicosinseln","TD_Tschad","TF_Franz\u00f6sische S\u00fcd- und Antarktisgebiete","TG_Togo","TH_Thailand","TJ_Tadschikistan","TK_Tokelau","TL_Timor-Leste","TM_Turkmenistan","TN_Tunesien","TO_Tonga","TR_T\u00fcrkei","TT_Trinidad und Tobago","TV_Tuvalu","TW_Taiwan","TZ_Tansania","UA_Ukraine","UG_Uganda","UM_Amerikanisch-Ozeanien","US_Vereinigte Staaten von Amerika","UY_Uruguay","UZ_Usbekistan","VA_Vatikanstadt","VC_St. Vincent und die Grenadinen","VE_Venezuela","VG_Britische Jungferninseln","VI_Amerikanische Jungferninseln","VN_Vietnam","VU_Vanuatu","WF_Wallis und Futuna","WS_Samoa","YE_Jemen","YT_Mayotte","ZA_S\u00fcdafrika","ZM_Sambia","ZW_Simbabwe","RS_Serbien","ME_Montenegro","BL_Saint-Barth\u00e9lemy","BQ_Bonaire, Sint Eustatius und Saba","CW_Cura\u00e7ao","MF_Saint-Martin (franz. Teil)","SX_Sint Maarten (niederl. Teil)","SS_Sudsudan"],
    result: false
  }
  let _pages = await store.dispatch('load', {mode: '/contributions/8/13', params: {references: 'false', populate: 'true'}});
  try {
    _loaders.translation.Documents.forEach(element => {
      _loaders.translation_parsed[element.Contribution.Name] = element.Data.translation.Parsed
      _loaders.translation_byid[element.Contribution.Name] =  element.Contribution.Id
    });
  } catch (error) {
    console.log(_loaders);
    return;
  }

  ['services','genres','mediatypes','languages'].forEach(key => {
    _loaders[key].Documents.forEach(element => {
      _loaders[`${key}_parsed`].push({
        translation: element.Data.translation.Parsed,
        id: element.Contribution.Id,
        active: false
      })
      _loaders[`${key}_byid`][element.Contribution.Id] = {
        translation: element.Data.translation.Parsed,
        id: element.Contribution.Id,
        active: false
      }
    });
    _loaders[`${key}_parsed`] = _.orderBy(_loaders[`${key}_parsed`], o => o.translation[0], 'asc');
  })

  _loaders.integration.Documents.forEach(element => {
    if (element.Data.input.Content[1]) {
      element.Data.input.Content[1] = JSON.parse(element.Data.input.Content[1]);
      if (element.Data.input.Content[1]) {
        for (let _token in element.Data.input.Content[1]) if (element.Data.input.Content[1].hasOwnProperty(_token)) {
          element.Data.input.Content[1][_token].pattern = RegExp(element.Data.input.Content[1][_token].pattern);
        }
      }
    }
    else {
      element.Data.input.Content[1] = false;
    }

    

    _loaders.integration_parsed.push(element)
    _loaders.integration_byid[element.Contribution.Id] = element
  });
  _loaders.integration_parsed = _.orderBy(_loaders.integration_parsed, o => o.Data.name.Content[0], 'asc');

  let _extended_form = {
    translator: [
      {id: '23',    name: 'extended_form:person:translator:quellsprache', type: 'select', value: _loaders.languages_parsed},
      {id: '24',    name: 'extended_form:person:translator:zielsprache', type: 'select', value: _loaders.languages_parsed}
    ],
    location: [
      {id: '9',     name: 'extended_form:person:kanton', type: 'select', value: _loaders.kanton},
      {id: '8',     name: 'extended_form:person:ort', type: 'text', value: ''}
    ],
    language: [
      {id: '14',    name: 'extended_form:person:literarische_sprache', type: 'select', value: _loaders.languages_parsed},
    ],
    person: [
      {id: '3',     name: 'extended_form:person:name', type: 'text', value: ''},
      {id: '4',     name: 'extended_form:person:vorname', type: 'text', value: ''},
      {id: '5',     name: 'extended_form:person:pseudonym', type: 'text', value: ''},
      {id: '8',     name: 'extended_form:person:ort', type: 'text', value: ''},
      {id: '9',     name: 'extended_form:person:kanton', type: 'select', value: _loaders.kanton},
      {id: '10',    name: 'extended_form:person:land', type: 'select', value: _loaders.land},
      {id: '14',    name: 'extended_form:person:literarische_sprache', type: 'select', value: _loaders.languages_parsed},
      {id: '20',    name: 'extended_form:person:angebote', type: 'select', value: _loaders.services_parsed},
      {id: '23',    name: 'extended_form:person:translator:quellsprache', type: 'select', value: _loaders.languages_parsed},
      {id: '24',    name: 'extended_form:person:translator:zielsprache', type: 'select', value: _loaders.languages_parsed},
      {id: '25',    name: 'extended_form:person:adsmitglied', type: 'radio', value: ['ja', 'nein']}

    ],
    werk: [
      {id: '29',    name: 'extended_form:werk:titel', type: 'text', value: ''},
      {id: '30',    name: 'extended_form:werk:untertitel', type: 'text', value: ''},
      {id: '40',    name: 'extended_form:werk:autor', type: 'text', value: ''},
      {id: '41',    name: 'extended_form:werk:coautor', type: 'text', value: ''},
      {id: '42',    name: 'extended_form:werk:herausgeber', type: 'text', value: ''},
      {id: '43',    name: 'extended_form:werk:uebersetzer', type: 'text', value: ''},
      {id: '35',    name: 'extended_form:werk:erscheinungsjahr', type: 'text', value: ''},
      {id: '39',    name: 'extended_form:werk:isbn', type: 'text', value: ''},
      {id: '33',    name: 'extended_form:werk:verlag', type: 'text', value: ''},
      {id: '34',    name: 'extended_form:werk:ort', type: 'text', value: ''},
      {id: '44',    name: 'extended_form:werk:buch:genre:literatur', type: 'select', value: _loaders.genres_parsed},
      {id: '37',    name: 'extended_form:werk:textsprache', type: 'select', value: _loaders.languages_parsed},
    ],
    other: [
      {id: '55',    name: 'extended_form:werk:autor', type: 'text', value: ''},
      {id: '45',    name: 'extended_form:werk:titel', type: 'text', value: ''},
      {id: '46',    name: 'extended_form:werk:untertitel', type: 'text', value: ''},
      {id: '51',    name: 'extended_form:werk:erscheinungsjahr', type: 'text', value: ''},
      {id: '54',    name: 'extended_form:werk:ean', type: 'text', value: ''},
      {id: '59',    name: 'extended_form:werk:andere:genre:medientyp', type: 'select', value: _loaders.mediatypes_parsed},
    ]
  }

  let _logindata = {};
  let result = await store.dispatch('check_session');
  if (result.error === false) {
    _logindata = result;
  }
  



  new Vue({
    router,
    store,
    data () {
      var _base_language   = 0;
      if (window.location.hostname.match(/repertoire/g))   _base_language = 1;
      if (window.location.hostname.match(/lessico/g))      _base_language = 2;
      if (window.location.hostname.match(/encyclopedia/g)) _base_language = 3;

      return {
        debugmode: {on: false},
        loading: true,
        language: _base_language,
        language_full: ['de','fr','it','en'][_base_language],
        categories: _loaders,
        extended_form: _extended_form,
        pages: _pages.Documents,
        isScrolled: false,
        isScrolledMore: false,
        login: false,
        formdata: {
          mode: 'simple',
          offset: 0,
          simple: {
            q: [],
            services: {},
            filter: 'person',
            translator: {},
            location: {},
            language: {},
          },
          extended: {
            filter: 'person'
          },
        },
        extended_form_fields: {
          werk: [],
          person: [],
          other: [],
          translator: _extended_form.translator,
          location: _extended_form.location,
          language: _extended_form.language
        },
        logindata: _logindata,
        loginCallback: function(){}
      }
    },
    render: h => h(App),
  
    /** - Loading Routes from Rokfor
      * - Creating vue Routes
      **/
  
    created: async function () {
      this.changeLanguage();
      window.addEventListener('scroll', this.scroll)
    },
    beforeDestroy: function () {
      window.removeEventListener('scroll', this.scroll)
    },
    methods: {
      close() {
        if (window.history.length > 2)
            this.$router.go(-1);
        else 
            this.$router.push('/');
      },
      scroll(e) {
        this.isScrolled = window.scrollY > 10;
        this.isScrolledMore = window.scrollY > 100;
      },
      resetForm(mode) {
        if (mode === 'simple') {
          this.formdata.simple = {
            q: "",
            services: {}
          }
        }
        if (mode === 'extended') {
          this.formdata.extended = {}
        }
      },
      u(string) {
        return string.replace(/[\W_]+/g, '_');
      },
      try(string, p) {
        try {
          return string[p].Parsed;
        } catch (error) {
          return "";
        }
      },
      toggleDebug() {
        alert("debug");
        this.debugmode.on = !this.debugmode.on
      },
      t(key) {
        if (this.categories.translation_parsed && this.categories.translation_parsed[key]) {
          if (this.debugmode.on) {
            return `${this.categories.translation_byid[key]}:${this.categories.translation_parsed[key][this.language]}`
          }
          else {
            return this.categories.translation_parsed[key][this.language]
          }
        }
        else 
          return `[!]${key}`;
      },
      j(strings, glue) {
        let r = "";
        glue = glue || " ";
        if (typeof strings === 'string') {
          return strings;
        }
        strings.forEach((s,k) => {
          if (s) {
            if (k>0 && r !== "") r += glue;
            r += s;
          }
        })
        return r;
      },
      changeLanguage(lang) {

        if (this.$route.params.mode === 'extended') {
          this.formdata.mode = 'extended'
        }
        

        /*if (lang === undefined) {
          if (this.$route.params.lang) {
            switch (this.$route.params.lang) {
              case 'Fr':
                this.language = 1;
                break;
              case 'It':
                this.language = 2;
                break;      
              case 'En':
                this.language = 3;
                break;      
              default:
                this.language = 0;
                break;
            }
          }
        }
        else {*/

        if (lang !== undefined) {
          this.language = lang;
          switch (this.language) {
            case 1:
              this.language_full = 'fr'  
              break;
            case 2:
              this.language_full = 'it'  
              break;
            case 3:
              this.language_full = 'en'
              break;
            default:
              this.language_full = 'de'
              break;                                                
            
          }
        }
        

        ['services','genres','mediatypes','languages'].forEach(key => {
          this.categories[`${key}_parsed`] = _.orderBy(this.categories[`${key}_parsed`], o => {return o.translation[this.language];}, 'asc');
        })

        this.applyStyle(this.generateStyleDef(this.language));
      },
      generateStyleDef(id) {
        return `
          .caption_${id} {
            display: block !important;
          }
        `;
      },
      applyStyle(styleDef) {
        Array.from(document.querySelectorAll('[data-style-controlled]')).map(el => el.parentNode.removeChild(el));
        let style = document.createElement('style');
        style.setAttribute('data-style-controlled', '');
        style.type = 'text/css';
        document.head.appendChild(style);
        style.innerHTML = styleDef;
      },
      loginmodal(_cb) {
        this.loginCallback = _cb || function(){}
        this.login = true; 
        this.$route.query.otc = false
      },
      logout() {
        this.logindata = this.$store.dispatch('load', {mode: '/logout'});
      }
    },
    watch: {
      '$route' (to, from) {
        this.changeLanguage();
      }
    }
  }).$mount('#app')
}









initialize();